export const worklistCopyDa = {
    worklist: "Opgaveliste",
    yourTasks: "Dine opgaver",
    description: "Udfyld klinikerformularer, samtykker og manglende hændelsesdetaljer på tværs af dine patienter.",
    emptyTitle: "Du er helt ajour",
    emptyDescription: "Der er ingen udestående klinikeropgaver lige nu.",
    noMatchingTasks: "Ingen matchende opgaver",
    noMatchingTasksDescription: "Prøv at ændre din søgning, fane eller filtre.",
    complete: "Udfyld",
    completeDetails: "Udfyld detaljer",
    completeDetailsPanelDescription: "Udfyld de manglende detaljer, og vend derefter tilbage til opgavelisten.",
    signConsent: "Underskriv samtykke",
    closePanel: "Luk panel",
    noTaskSelected: "Vælg en opgave",
    noTaskSelectedDescription:
        "Vælg en række for at udfylde en formular, et samtykke eller manglende hændelsesoplysninger her.",
    openDiary: "Åbn dagbog",
    openPatient: "Åbn patient",
    toDo: "Opgaver",
    refresh: "Opdater",
    forms: "Formularer",
    details: "Detaljer",
    archived: "Arkiveret",
    archive: "Arkiver",
    archiveAll: "Arkiver alle",
    restoreAll: "Gendan alle",
    tasksSelected: (count: number) => (count === 1 ? "1 opgave valgt" : `${count} opgaver valgt`),
    selectedTasksDescription: "Vælg en handling for de valgte opgaver.",
    selectTask: "Vælg opgave",
    selectAllTasks: "Vælg alle opgaver",
    restore: "Gendan",
    archiveSucceeded: (count: number) => (count === 1 ? "Opgaven er arkiveret." : `${count} opgaver er arkiveret.`),
    archiveFailed: "Kunne ikke arkivere denne opgave. Prøv igen.",
    restoreSucceeded: (count: number) => (count === 1 ? "Opgaven er gendannet." : `${count} opgaver er gendannet.`),
    restoreFailed: "Kunne ikke gendanne denne opgave. Prøv igen.",
    emptyArchivedTitle: "Intet arkiveret",
    emptyArchivedDescription: "Opgaver, du arkiverer, bliver her, indtil du gendanner dem.",
    allPeople: "Alle personer",
    peopleFilterLabel: "Personer",
    selectPeople: "Vælg klinikere",
    organisationFilterLabel: "Organisation",
    allOrganisations: "Alle organisationer",
    taskTypeFilterLabel: "Opgavetype",
    allTaskTypes: "Alle opgavetyper",
    searchTasks: "Søg i opgaver",
    clearSearch: "Ryd opgavesøgning",
    filterTasks: "Filtrer opgaver",
    filterTasksDescription: "Vælg personer, organisation og opgavetype.",
    taskCompleteTitle: "Opgave gemt",
    taskCompleteDescription: "Fortsæt til den næste person på din opgaveliste, når du er klar.",
    taskCompleteAllDoneTitle: "Alt udført",
    taskCompleteAllDoneDescription: "Der er ikke flere opgaver på denne liste.",
    continueToNextTask: "Fortsæt til næste opgave",
    doNext: "Gør det næste",
    doNextDescription: (task: string, patientName: string, hospitalNumber: string | null) =>
        hospitalNumber
            ? `${task} for ${patientName}. Hospitalsnummer: ${hospitalNumber}`
            : `${task} for ${patientName}`,
    nextPatientTask: (name: string) => `Næste: ${name}`,
    returnToWorklist: "Tilbage til opgavelisten",
    patient: "Patient",
    hospitalNumber: "Hospitalsnummer",
    task: "Opgave",
    injectionDetailsTask: "Injektionsdetaljer",
    surgeryDetailsTask: "Operationsdetaljer",
    shockwaveDetailsTask: "Chokbølgedetaljer",
    procedureDetailsTask: "Proceduredetaljer",
    consentTask: "Samtykke",
    due: "Forfalden",
    status: "Status",
    actions: "Handlinger",
    dueLabel: "Forfalden",
    blockedLabel: "Blokeret",
    incompleteLabel: "Ufuldstændig",
    blockedBy: (blocker: string) => `Udfyld ${blocker} først`,
    truncatedNotice: (total: number, shown: number) =>
        `Viser de første ${shown} af ${total} dagbøger med klinikerformularer. Begræns din patientliste, hvis du har brug for resten.`,
    unknownPatient: "Ukendt patient",
    notDefined: "Ikke angivet",
    loading: "Indlæser opgaveliste…",
    errorLoading: (message: string) => `Kunne ikke indlæse opgaveliste: ${message}`,
    taskCount: (count: number) => (count === 1 ? "1 opgave" : `${count} opgaver`),
};
